export default "__VITE_ASSET__BOGJ7CZ1__"